<template>
  <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
      <div class="container-post">
        <div class="form-modal">
          <h2>Add Category</h2>
          <button  class="close" @click="back()"></button>
            <div class="wrapper">
              <div class="input-data mg-top1">
                  <input type="text" required v-model="order_id">
                  <div class="underline"></div>
                  <label>Order Id</label>
              </div>
              <div class="input-data mg-top">
                <input type="text" required v-model="name">
                <div class="underline"></div>
                <label>Title</label>
              </div>
              <div class="text-area mg-top">
                  <textarea v-model="description" required></textarea>
                  <div class="underline"></div>
                  <label>Description</label>
              </div>
            </div> 
            <div class="btn-heading">
              <p class="mg-top" v-if="errors.length">
                  <b>Please correct the following error(s):</b>
                  <ul>
                      <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                  </ul>
              </p>

              <button class="btn-add mg-top1" @click="validation(id != 0 ? 'update' : 'add')">
                {{id != 0? 'Update' : 'Add'}} Post
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';

export default {
  name: 'FormCategory',
  data () {
    return {
      isLoading: false,
      id: '',
      type: '',
      order_id: '',
      name: '',
      description: '',
      errors: []
    }
  },
  methods: {
    validation(type) {
        this.errors = []
        
        if (!this.order_id) this.errors.push('* OrderId required')
        if (!this.name) this.errors.push('* Title required')
        
        if (this.errors.length > 0) {
            return
        } else if (type === 'add') {
            this.addCategory()
        } else if (type === 'update') {
            this.updateCategory()
        }
    },
    addCategory() {
      if (this.type === 'berita' ) {
          this.addCatNews();
      }
    },
    updateCategory() {
      if (this.type === 'berita' ) {
        this.updateNews();
      }
    },
    async addCatNews() {
      try {
        this.isLoading = true
        const formData = new FormData()

        formData.append('order_id', this.order_id)
        formData.append('name', this.name)
        formData.append('description', this.description)

        const response = await axios.post('/content/newscategory', formData)
        this.isLoading = false

        console.log(response)
        if(response.status == 200) {
            alert.success('Add data success', () => this.$router.go(-1))
        }
      } catch (error) {
        console.log(error)
      }
    },
    back() {
        this.$router.go(-1)
    },
    async getDataCatNews() {
      let dataId = localStorage.getItem('dataCatBerita')

      let data = JSON.parse(dataId)

      this.order_id = data.order_id
      this.name = data.name
      this.description = data.description.String
    },
    async updateNews() {
        try {
            this.isLoading = true
            const formData = new FormData()

            formData.append('order_id', this.order_id)
            formData.append('name', this.name)
            formData.append('description', this.description)

            const response = await axios.patch(`/content/newscategory/${this.id}`, formData)
            this.isLoading = false

            console.log(response)
            if(response.status == 200) {
                alert.success('Update data success', () => this.$router.go(-1))
            }
      } catch (error) {
        console.log(error)
      }
    }
  },
  components: {
    Loader
  },
  created() {
      this.id = this.$route.params.id
      this.type = this.$route.params.type

      if (this.id != 0 && this.type === 'berita') {
          this.getDataCatNews()
      } 
  }
}
</script>